// Sarvaguna illustrations. Each picture is a plain image file in
// frontend/public/illustrations/ (480 x 360, 4:3). To use a real photo
// later, save a 4:3 photo with the same file name (or change FILES below).
import React from 'react';
import { network } from './content';
const FILES = {
  hero: 'hero', thali: 'thali', kitchen: 'kitchen', nutrition: 'nutrition',
  hospital: 'hospital', tray: 'hospital',
  events: 'events', buffet: 'events',
  products: 'products', shelf: 'products',
  farmers: 'farmers', farmer: 'farmers',
  academy: 'academy', apprentice: 'academy',
  delivery: 'delivery', van: 'delivery',
  bakery: 'bakery', noodles: 'noodles', yogiboost: 'yogiboost', flour: 'flour', pickles: 'pickles',
  boxes: 'boxes',
};
const ALT = {
  hero: 'Students in school uniform eating dal bhat together while a cook serves',
  thali: 'A thali of dal, rice, greens, vegetable curry and achar',
  kitchen: 'Two cooks, a woman and a man, at large pots in the central kitchen',
  nutrition: 'A nutritionist with a menu plan beside a chef presenting a balanced meal',
  hospital: 'A canteen cook hands a meal tray to a nurse while a medical student waits',
  events: 'Guests in a sari and a daura suruwal with dhaka topi at an event buffet',
  products: 'A young woman choosing pickles, noodles, flour, millet bread and Yogi Boost from a shelf',
  farmers: 'A woman farmer with a doko of greens and a man farmer with a crate of tomatoes',
  academy: 'An instructor teaching two apprentices, a young man and a young woman, in chef whites',
  delivery: 'A Sarvaguna van driving up a hill road to a school where children wave',
  bakery: 'Multigrain loaf, millet buns and biscuits on a wooden board',
  noodles: 'A bowl of multigrain noodles with vegetables beside a noodles packet',
  yogiboost: 'Two Yogi Boost bottles and a glass of the drink with nuts and millet',
  flour: 'A sack of multigrain flour with a scoop and piles of maize, millet and wheat',
  pickles: 'Three jars of Nepali achar: mango, chilli and radish',
  boxes: 'Sarvaguna boxed meals: an open meal box with rice, dal, greens and curry, a stack of boxes and an insulated delivery bag',
};
// Picture for a product: the one chosen in the admin, else guessed from the name.
export function productArt(p) {
  if (p && p.art && FILES[p.art]) return p.art;
  const n = String((p && p.name) || '').toLowerCase();
  if (/bak|bread|biscuit|cookie|bun/.test(n)) return 'bakery';
  if (/noodle/.test(n)) return 'noodles';
  if (/yogi|boost|drink|beverage/.test(n)) return 'yogiboost';
  if (/flour|atta/.test(n)) return 'flour';
  if (/pickle|achar/.test(n)) return 'pickles';
  return 'products';
}
export const artSrc = (name) => `/illustrations/${FILES[name] || 'thali'}.svg`;
// Kept so older imports keep working. The grain is now inside each image file.
export function GrainDefs() {
  return null;
}
export function Art({ name, className = '' }) {
  const file = FILES[name] || 'thali';
  return (
    <div className={`sg-art ${className}`}>
      <img src={`/illustrations/${file}.svg`} alt={ALT[file]} width="480" height="360" loading="lazy" decoding="async" />
    </div>
  );
}
function Arrow({ label }) {
  return (
    <li className="sg-net__arrow" aria-hidden="true">
      <span>{label}</span>
      <svg viewBox="0 0 60 16" width="60" height="16"><path d="M2 8h50M44 2l8 6-8 6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </li>
  );
}
function Node({ n }) {
  return (
    <li className="sg-net__node">
      <img src={artSrc(n.img)} alt="" width="480" height="360" loading="lazy" />
      <b>{n.title}</b>
      <span>{n.text}</span>
    </li>
  );
}
// The food network model: farmers -> central kitchen -> canteens -> people,
// with income flowing back to farmers and the Academy training cooks.
export function NetworkModel({ compact = false }) {
  const [a, b, c, d] = network.nodes;
  return (
    <figure className={`sg-net${compact ? ' sg-net--compact' : ''}`} aria-label={network.title}>
      <ol className="sg-net__flow">
        <Node n={a} />
        <Arrow label={network.links[0]} />
        <Node n={b} />
        <Arrow label={network.links[1]} />
        <Node n={c} />
        <Arrow label={network.links[2]} />
        <Node n={d} />
      </ol>
      <div className="sg-net__support">
        <p className="sg-net__back">
          <svg viewBox="0 0 60 16" width="44" height="14" aria-hidden="true"><path d="M58 8H8M16 2L8 8l8 6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
          {network.back}
        </p>
        <div className="sg-net__academy">
          <img src={artSrc(network.academy.img)} alt="" width="480" height="360" loading="lazy" />
          <div>
            <b>{network.academy.title}</b>
            <span>{network.academy.text}</span>
          </div>
        </div>
      </div>
      <figcaption className="sg-visually-hidden">{network.lead}</figcaption>
    </figure>
  );
}
